import { render, staticRenderFns } from "./AddOnboardingToSpaceComponent.vue?vue&type=template&id=e2c4c508&scoped=true&"
import script from "./AddOnboardingToSpaceComponent.vue?vue&type=script&lang=js&"
export * from "./AddOnboardingToSpaceComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddOnboardingToSpaceComponent.vue?vue&type=style&index=0&id=e2c4c508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c4c508",
  null
  
)

export default component.exports